import apiService from "./BaseApi";
import store from '@/store/index'

const BASE_ENDPOINT_CONTRACT = "/contracts"

const ContractsTemplatesService = {
    saveTemplate: async (contractTemplateData) => apiService.post(BASE_ENDPOINT_CONTRACT, {
        ...contractTemplateData,
        currentUserId: store.state.currentUser?.uid
    }),
    generateContract: async (contractData) => apiService.post(`${BASE_ENDPOINT_CONTRACT}/generate-contract`, {
        ...contractData,
        currentUserId: store.state.currentUser?.uid,
    }),
    deleteTemplateContract: async (contractTemplateId) => apiService.delete(`${BASE_ENDPOINT_CONTRACT}/${contractTemplateId}`),
    getTemplateById: async (contractTemplateId) => apiService.get(`${BASE_ENDPOINT_CONTRACT}/${contractTemplateId}`),
    getAll: async () => apiService.get(BASE_ENDPOINT_CONTRACT),
    getActives: async () => apiService.get(`${BASE_ENDPOINT_CONTRACT}/active`),
}

export default ContractsTemplatesService;